var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.src}},[_c('p',[_vm._v("Your browser does not support iframes.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }